



















import UniversalSelectInput from "../form/UniversalSelectInput.vue";
import SelectInput from "../form/SelectInput.vue";
import {
  createComponent,
  createElement,
  ref,
  onMounted,
} from "@vue/composition-api";
import { useActions } from "@/shared/useMegaraxClient";
import { IncompleteResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { Select } from "element-ui";
import { Resource } from "@megarax/client/src";
import { ListActions } from "@megarax/client/src/actions";

interface Props {
  value: any;
  filters: object;
  resource: Resource<ListActions<any>>;
}

export default createComponent<Props>({
  components: {
    SelectInput,
    UniversalSelectInput,
  },
  props: {
    value: {
      required: true,
    },
    filters: { default: () => ({}) },
    resource: { required: true },
  },
  setup(props, ctx) {
    const items = ref<IncompleteResourceItem[]>(
      (props.value ? [props.value] : []).flat(),
    );
    const fetching = ref<boolean>(false);

    let currentSearchText = "";

    const actions = useActions(props.resource);

    async function onSearch(searchText: string) {
      currentSearchText = searchText;
      if (fetching.value) return;
      fetching.value = true;

      const resp = await actions.fetchListLimitOffset(20, 0, {
        search: searchText,
        ...props.filters,
      });

      fetching.value = false;

      if (currentSearchText == searchText) items.value = resp.items;
      // search again if the search text has changed
      else onSearch(currentSearchText);
    }

    const onInput = (val: any) => {
      ctx.listeners.input(val || null);
    };

    onSearch("");

    return { items, onSearch, fetching, onInput };
  },
});
